import ServiceForm from "./ServiceForm";

export default function CreateService() {
  return <ServiceForm mode="create" />;
}
